import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { FieldGroup } from '../../../libs/formLib';

/**
 * Renders a single credential input field from a schema field definition.
 * Delegates to the existing FieldGroup component for consistent styling.
 *
 * Schema field shape:
 * {
 *   id: string,          // Field id (maps to fields[id])
 *   type: string,        // "text", "password", "number"
 *   label: string,       // Display label
 *   placeholder: string, // Input placeholder
 *   required: boolean,   // Whether field is required
 *   colSize: number,     // Bootstrap column size (default 6)
 *   feedback: string,    // Validation feedback message
 *   className: string    // Optional custom CSS class
 * }
 */
const DynamicCredentialField = ({ field, value, onChange, isSubmitted }) => {
  const colSize = field.colSize || 6;

  return (
    <Col lg={String(colSize)} className={field.className || ''}>
      <FieldGroup
        type={field.type || 'text'}
        id={field.id}
        autoComplete={`new-${field.id}`}
        onChange={onChange}
        value={value || ''}
        label={field.label}
        data-testid={`dynamic-cred-${field.id}`}
        showFeedback={!value && isSubmitted}
        feedback={field.feedback || `${field.label} is required.`}
        placeholder={field.placeholder || ''}
        required={field.required}
      />
    </Col>
  );
};

DynamicCredentialField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    colSize: PropTypes.number,
    feedback: PropTypes.string,
    className: PropTypes.string
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool
};

export default DynamicCredentialField;
